@for (notification of dataSet; track notification; let i = $index) {
  <div
    class="d-flex flex-column notification-item"
    (click)="readNotification(notification)"
    >
    <div class="d-flex mb-2" [ngClass]="{ pointer: !notification.isRead }">
      <div class="title">
        {{ notification.date | date: "dd/MM/yyyy - HH:mm" }}
      </div>
      <div class="ms-auto">
        @if (notification.isRead) {
          <h2
            class="badge badge-pill badge-light color-orange"
            >
            <img src="/assets/images/icons/check.svg" />
            Letto
          </h2>
        }
        @if (!notification.isRead) {
          <h2 class="badge badge-pill badge-primary">
            Nuovo
          </h2>
        }
      </div>
    </div>
    <div class="desc">
      {{ truncateText(notification.description, notification.isRead) }}
    </div>
    <div>
      <hr class="mt-3 mb-3 d-block" />
    </div>
  </div>
}
